import type { TranslationKeysMapper } from '@modules/i18n/types';
import { AppModule } from '@modules/core/plugins/AppModule';

import {
  TRANSLATION_GROUP_INTERFACE_CONFIRM_OPEN_LINK,
  TRANSLATION_GROUP_INTERFACE_LANGUAGES,
  TRANSLATION_GROUP_INTERFACE_TOASTS,
} from './constants';
import { getTranslationConfirmOpenLinkKeys, getTranslationKeys, getTranslationToastsKeys } from './translations';

export class I18nModule extends AppModule {
  addRoutes(): void {}

  addMenu(): void {}

  addTranslationKeys(mapper: TranslationKeysMapper): void {
    mapper.addTranslationsMap(TRANSLATION_GROUP_INTERFACE_LANGUAGES, getTranslationKeys);
    mapper.addTranslationsMap(TRANSLATION_GROUP_INTERFACE_TOASTS, getTranslationToastsKeys);
    mapper.addTranslationsMap(TRANSLATION_GROUP_INTERFACE_CONFIRM_OPEN_LINK, getTranslationConfirmOpenLinkKeys);
  }
}
